module.exports = __webpack_public_path__ + "img/css.33c26339.svg";